import { v4 as uuid } from 'uuid';
import { NodeType } from '@amplify/amp-module';
import InsightsNodeHandler from '../insights-node-handler';
import { endpoints } from '../../../../constants/endpoints';

export default class OpenHandler extends InsightsNodeHandler {
  constructor(ctx) {
    super(ctx, NodeType.open);
    this.ctx = ctx;
  }

  async handleNode(node) {
    await super.handleNode(node, { addToStack: true, handleStorage: false });

    const isPreview = this.store.getters['chatbotStore/isPreview'];
    const nextNode = this.store.getters['chatbotStore/nextNode'](node.id);

    if (isPreview) {
      return nextNode;
    }

    const errorNode = {
      id: `${NodeType.message}-${uuid()}`,
      type: NodeType.message,
      html: `<p><em>Error: Couldn't load eDetail</em></p>`,
    };

    try {
      const {
        data: { data, domains, version },
      } = await this.ctx.$amplifyApi.get(endpoints.amp.publishedById(node.ampId));

      if (!data) {
        this.store.dispatch('chatbotStore/addNode', errorNode);
        return nextNode;
      }

      this.trackResponseEvent('selfDetailerChange', {
        openId: node.id,
        changeEvent: 'OPEN',
      });

      await this.store.dispatch('chatbotStore/setupConversation', null);
      await this.store.dispatch('chatbotStore/setAmpSetupOptions', {
        conversationId: node.conversationId,
        ampId: node.ampId,
      });
      await this.store.dispatch('chatbotStore/pushAmp', { ...data, domains, ampVersion: version });
    } catch (error) {
      this.store.dispatch('chatbotStore/addNode', errorNode);
      return nextNode;
    }

    return undefined;
  }
}
